// test2955
(2955 && 0);
